// @flow
import { RESORT_MEETING_ROOM_INFO } from 'Client/cms/toolkit/constants';
import { buildProductArgs } from 'Utils/graphql';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_MEETING_ROOM_INFO } from 'Utils/request/requestDictionary';

type GQLProps = {
  productMeetingRooms: Array<{
    label: string,
    area: Measure,
    length: Measure,
    width: Measure,
  }>,
};

export const productMeetingRoomInfoResolver = {
  name: RESORT_MEETING_ROOM_INFO,
  resolve(
    appContext: AppContext,
    props: {
      resortId: string,
    },
    pageContext: PageContext,
    location: ProductRouterLocation,
  ): Promise<GQLProps> {
    const { resortId } = props;
    const { urlParams } = location;
    const productArgs = buildProductArgs(resortId, urlParams);

    const query = `{
        productMeetingRooms(${productArgs}) {
          availableMeetingRoomShapes
          meetingRooms {
            label
            area {
              value
              unit
            }
            length {
              value
              unit
            }
            width {
              value
              unit
            }
            shapes {
              type
              maxCapacity
            }
          }
        }
    }`;
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_MEETING_ROOM_INFO,
      strictErrors: false,
    });
  },
};
